function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.316,
  y: 0.236,
  width: 45.394,
  height: 45.394,
  rx: 9.079,
  fill: "#EDF3FD"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 25.999,
  y: 11.675,
  width: 4.41,
  height: 22.33,
  rx: 2.205,
  stroke: "#1F71E4",
  strokeWidth: 1.35
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.965 22.76h8.48",
  stroke: "#1F71E4",
  strokeWidth: 1.35,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.004 17.96h4.3M26.004 28.6h4.3",
  stroke: "#1F71E4",
  strokeWidth: 1.35,
  strokeLinecap: "square"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.086,
  cy: 29,
  r: 4.845,
  stroke: "#1F71E4",
  strokeWidth: 1.35
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.413,
  cy: 27.64,
  r: 0.8,
  fill: "#1F71E4"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.769,
  cy: 27.64,
  r: 0.8,
  fill: "#1F71E4"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M15.305 30.92s.48-1.253 1.76-1.28c1.28-.027 1.84 1.28 1.84 1.28",
  stroke: "#1F71E4",
  strokeWidth: 1.35,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.086,
  cy: 16.68,
  r: 4.845,
  stroke: "#1F71E4",
  strokeWidth: 1.35
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.413,
  cy: 15.32,
  r: 0.8,
  fill: "#1F71E4"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.769,
  cy: 15.32,
  r: 0.8,
  fill: "#1F71E4"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M15.305 17.52s.48 1.253 1.76 1.28c1.28.026 1.84-1.28 1.84-1.28",
  stroke: "#1F71E4",
  strokeWidth: 1.35,
  strokeLinecap: "round"
});

var SvgReportSentiment = function SvgReportSentiment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 46 46",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

export default SvgReportSentiment;